// extracted by mini-css-extract-plugin
export var author = "index-module--author--Xx5GU";
export var authorBio = "index-module--authorBio--78LBh";
export var authorImg = "index-module--authorImg--esLeG";
export var authorMeta = "index-module--authorMeta--bIpZL";
export var authorMetaBottom = "index-module--authorMetaBottom--oKm0t";
export var authorMetaName = "index-module--authorMetaName--0t88c";
export var authorMetaTitle = "index-module--authorMetaTitle--Yv7wN";
export var authorMetaTop = "index-module--authorMetaTop--Fg2by";
export var backLink = "index-module--backLink--ZUCcI";
export var blackCircle = "index-module--blackCircle--ROpll";
export var content = "index-module--content--WkZtQ";
export var date = "index-module--date--TLchg";
export var defaultImageContainer = "index-module--defaultImageContainer--wgwva";
export var defaultImageInnerContainer = "index-module--defaultImageInnerContainer--h9eMT";
export var hero = "index-module--hero--DNGB7";
export var inlineGatsbyImageWrapper = "index-module--inline-gatsby-image-wrapper--ymC-v";
export var innerAuthor = "index-module--innerAuthor--H3h40";
export var leftArrow = "index-module--leftArrow--vK1mK";
export var ousterAuthorDetail = "index-module--ousterAuthorDetail--RWhNp";
export var previewCardContainer = "index-module--previewCardContainer--qBp5H";
export var title = "index-module--title--dh+dX";
export var wrapper = "index-module--wrapper--h1xD7";